"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPlain = exports.toPlains = void 0;
var isarray_1 = __importDefault(require("isarray"));
var utils_1 = require("./utils");
var classToObject = function (keyStore, instance, Clazz, options) {
    var obj = {};
    keyStore.forEach(function (propertiesOption, key) {
        var isValueNotExist = options.distinguishNullAndUndefined ? utils_1.isUndefined : utils_1.isNullOrUndefined;
        var instanceValue = isValueNotExist(instance[key]) ? propertiesOption.default : instance[key];
        var originalKey = propertiesOption.originalKey, afterSerializer = propertiesOption.afterSerializer, serializer = propertiesOption.serializer, targetClass = propertiesOption.targetClass, optional = propertiesOption.optional, array = propertiesOption.array, dimension = propertiesOption.dimension;
        var disallowIgnoreSerializer = propertiesOption.disallowIgnoreSerializer || !options.ignoreSerializer;
        var disallowIgnoreAfterSerializer = propertiesOption.disallowIgnoreAfterSerializer || !options.ignoreAfterSerializer;
        if (isValueNotExist(instanceValue)) {
            if (!optional) {
                throw new Error("Property '" + Clazz.name + "." + key + "' not found");
            }
            return;
        }
        var value = serializer && disallowIgnoreSerializer ? serializer(instanceValue, instance, obj, options) : instanceValue;
        if (value && targetClass) {
            if (array) {
                if (dimension === 1) {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    value = exports.toPlains(value, targetClass, options);
                }
                else {
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    value = value.map(function (cur) { return exports.toPlains(cur, targetClass, options); });
                }
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                value = exports.toPlain(value, targetClass, options);
            }
        }
        obj[originalKey] =
            afterSerializer && disallowIgnoreAfterSerializer ? afterSerializer(value, instance, obj, options) : value;
    });
    return obj;
};
exports.toPlains = function (instances, Clazz, options) {
    if (options === void 0) { options = {}; }
    if (!isarray_1.default(instances)) {
        throw new Error(Clazz + " instances must be an array");
    }
    var keyStore = utils_1.getKeyStore(Clazz);
    return instances.map(function (item) { return classToObject(keyStore, item, Clazz, options); });
};
exports.toPlain = function (instance, Clazz, options) {
    if (options === void 0) { options = {}; }
    return classToObject(utils_1.getKeyStore(Clazz), instance, Clazz, options);
};
//# sourceMappingURL=to-plain.js.map